export default __webpack_public_path__ + "static/media/image.d3160207.JPG";